import { IDictionary } from '~utilities/IDictionary';
import DisbursementTypeEnum from '~Api/Application/DisbursementTypeEnum';

const disbursementTypeLabels: IDictionary<string> = {
    [DisbursementTypeEnum.EstablishmentFee]: 'Establishment Fee',
    [DisbursementTypeEnum.LendersOutlays]: 'Lenders Outlays',
    [DisbursementTypeEnum.OtherRetainedFunds]: 'Other Retained Funds',
    [DisbursementTypeEnum.PrepaidInterest]: 'Prepaid Interest',
    [DisbursementTypeEnum.RetainedContingency]: 'Retained Contingency',
    [DisbursementTypeEnum.RetainedFunds]: 'Retained Funds',
};

export default disbursementTypeLabels;
